import { NavigateNext, NavigateBefore } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';
import {
    Box, Typography, Grid, Card, CardContent, Button,
    Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper,
    Chip, TextField, InputAdornment, Dialog, DialogTitle, DialogContent,
    DialogActions, Autocomplete, CircularProgress, Alert, Divider,FormControl,Select,MenuItem
} from '@mui/material';
import {
    Search, Plus, FileText, CreditCard, Users, DollarSign,
    CheckCircle2, Clock, XCircle, Send, Eye
} from 'lucide-react';
import { api } from '../context/AuthContext';
import { FilterList } from "@mui/icons-material";

const StatusChip = ({ status }) => {
    const configs = {
        draft: { color: 'default', label: 'Draft' },
        sent: { color: 'primary', label: 'Sent', icon: <Send size={14} /> },
        paid: { color: 'success', label: 'Paid', icon: <CheckCircle2 size={14} /> },
        expired: { color: 'warning', label: 'Expired' },
        cancelled: { color: 'error', label: 'Cancelled' }
    };
    const config = configs[status.toLowerCase()] || configs.draft;
    return (
        <Chip
            size="small"
            label={config.label}
            color={config.color}
            icon={config.icon}
            sx={{ fontWeight: 600 }}
        />
    );
};

const CustomPricingDashboard = () => {
    const [metrics, setMetrics] = useState({
        total_quotes: 0,
        pending_payments: 0,
        paid_quotes: 0,
        total_revenue: 0,
        active_custom_companies: 0
    });

    const [quotes, setQuotes] = useState([]);
    const [quoteFilter, setQuoteFilter] = useState("all");
    {/*const [filterAnchor, setFilterAnchor] = useState(null);*/}
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;
    /*const totalPages = Math.ceil(quotes.length / rowsPerPage);*/
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [successDialog, setSuccessDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    // Form State
    const [searchTerms, setSearchTerms] = useState('');
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [searching, setSearching] = useState(false);
    const [searchError, setSearchError] = useState(null);
    const [formData, setFormData] = useState({
        jobs_quantity: 1,
        applications_quantity: 60,
        call_alerts_quantity: 0,
        whatsapp_alerts_quantity: 0,
        negotiated_amount: ''
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const [mRes, qRes] = await Promise.all([
                api.get('/custom-pricing/metrics'),
                api.get('/custom-pricing/quotes')
            ]);
            setMetrics(mRes.data);
            setQuotes(qRes.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchCompanies = async (val) => {
        if (!val || val.length < 2) {
            setCompanies([]);
            return;
        }
        try {
            setSearching(true);
            setSearchError(null);
            const res = await api.get(`/custom-pricing/companies/search?term=${encodeURIComponent(val)}`);
            setCompanies(res.data);
        } catch (error) {
            console.error('Error searching companies:', error);
            setSearchError('Failed to fetch companies');
        } finally {
            setSearching(false);
        }
    };

    const handleCreateQuote = async () => {
        try {
            const payload = {
                ...formData,
                company_id: selectedCompany.company_id,
                recruiter_id: selectedCompany.recruiter_id
            };
            await api.post('/custom-pricing/quotes', payload);
            setOpenModal(false);
            // Reset form
            setFormData({
                jobs_quantity: 1,
                applications_quantity: 60,
                call_alerts_quantity: 0,
                whatsapp_alerts_quantity: 0,
                negotiated_amount: ''
            });
            setSelectedCompany(null);
            fetchData();
        } catch (error) {
            alert('Error creating quote');
        }
    };

    const handleGenerateLink = async (quoteId) => {
        try {
            await api.post(
                `/custom-pricing/quotes/${quoteId}/generate-payment-link`
            );

            setSuccessMessage(
                'The payment link has been generated successfully and delivered to the recruiter via email.'
            );

            setSuccessDialog(true);

            fetchData();
        } catch (error) {
            console.error(error);

            setSuccessMessage(
                'Unable to generate the payment link. Please try again.'
            );

            setSuccessDialog(true);
        }
    };
    const filteredQuotes = quotes.filter((quote) => {
        const status = quote.status?.toLowerCase();

        switch (quoteFilter) {
            case "all":
                return true;

            case "paid":
                return status === "paid";

            case "pending":
                return ["sent", "payment_pending" ,"pending"].includes(status);

            case "draft":
                return status === "draft";

            default:
                return true;
        }
    });

    const totalPages = Math.ceil(filteredQuotes.length / rowsPerPage);


    return (
        <Box sx={{ p: 4, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <Box
              sx={{
                mb: 4,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box>
                  {/*<Typography
                  sx={{
                    color: "#1E3A8A",
                    fontSize: {
                      xs: "2rem",
                      sm: "2.3rem",
                      md: "2.6rem",
                    },
                    fontWeight: 800,
                    lineHeight: 1.2,
                    mb: 0.8,
                  }}
                >*/}
                  <Typography
                      variant="h4"
                      sx={{
                          color: "#1E3A8A",
                          fontWeight: "bold",
                          fontSize: { xs: "1.5rem", md: "2rem" }
                      }}
                  >
                  Custom Pricing & Quotes
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    fontSize: "1rem",
                    fontWeight: 400,
                  }}
                >
                  Create, manage, and monitor custom pricing proposals for enterprise recruiters.
                </Typography>
              </Box>

                {/*<Button
                variant="contained"
                startIcon={<Plus size={18} />}
                onClick={() => setOpenModal(true)}
                sx={{
                  borderRadius: "8px",
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                  textTransform: "none",
                }}
              >
                Create Custom Quote
              </Button> */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center"
                    }}
                >
                    <FormControl size="small">
                        <Select
                            value={quoteFilter}
                            onChange={(e) => {
                                setQuoteFilter(e.target.value);
                                setPage(1);
                            }}
                            displayEmpty
                            renderValue={() => (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        color: "#1E3A8A",
                                        fontWeight: "bold"
                                    }}
                                >
                                    <FilterList sx={{ fontSize: 20 }} />
                                    Filters
                                </Box>
                            )}
                            sx={{
                                width: 160,
                                height: 48,
                                borderRadius: 0,

                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1E3A8A",
                                },

                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1E40AF",
                                },

                                "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                }
                            }}
                        >
                            <MenuItem
                                disabled
                                sx={{
                                    fontWeight: "bold",
                                    color: "#1E3A8A",
                                    borderBottom: "1px solid #eee",
                                    justifyContent: "center",
                                    opacity: "1 !important"
                                }}
                            >
                                Filters
                            </MenuItem>

                            <MenuItem value="all">
                                Total Quotes
                            </MenuItem>

                            <MenuItem value="paid">
                                Paid Quotes
                            </MenuItem>

                            <MenuItem value="pending">
                                Pending Payments
                            </MenuItem>

                            <MenuItem value="draft">
                                Draft Quotes
                            </MenuItem>

                        </Select>
                    </FormControl>

                    <Button
                        variant="contained"
                        startIcon={<Plus size={18} />}
                        onClick={() => setOpenModal(true)}
                        sx={{
                            borderRadius: "8px",
                            px: 3,
                            py: 1,
                            fontWeight: 600,
                            textTransform: "none",
                        }}
                    >
                        Create Custom Quote
                    </Button>
                </Box>
            </Box>

            {/* Metrics */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
                {[
                    { label: 'Total Quotes', value: metrics.total_quotes, icon: <FileText color="#1e3a8a" />, color: '#1e3a8a' },
                    { label: 'Pending Payments', value: metrics.pending_payments, icon: <Clock color="#f59e0b" />, color: '#f59e0b' },
                    { label: 'Paid Quotes', value: metrics.paid_quotes, icon: <CheckCircle2 color="#10b981" />, color: '#10b981' },
                    { label: 'Total Revenue', value: `₹${Number(metrics.total_revenue).toLocaleString()}`, icon: <DollarSign color="#059669" />, color: '#059669' },
                    { label: 'Active Companies', value: metrics.active_custom_companies, icon: <Users color="#3b82f6" />, color: '#3b82f6' }
                ].map((stat, i) => (
                    <Grid item xs={12} sm={6} md={2.4} key={i}>
                        <Card sx={{ borderRadius: '12px', borderBottom: `4px solid ${stat.color}` }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {stat.icon}
                                    <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary', fontWeight: 600 }}>{stat.label}</Typography>
                                </Box>
                                <Typography variant="h5" sx={{ fontWeight: 800 }}>{stat.value}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Quotes Table */}
            <TableContainer component={Paper} sx={{ borderRadius: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
                <Table>
                    <TableHead sx={{ bgcolor: '#f1f5f9' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700 }}>Quote ID</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Company</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Recruiter</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Purchase</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Amount</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Created Date</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredQuotes
                            .slice(
                                (page - 1) * rowsPerPage,
                                page * rowsPerPage
                            )
                            .map((quote) => (
                            <TableRow key={quote.id} hover>
                                <TableCell sx={{ fontWeight: 600 }}>{quote.quote_id}</TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{quote.company_name}</Typography>
                                    <Typography variant="caption" color="text.secondary">{quote.formatted_company_id}</Typography>
                                </TableCell>
                                <TableCell>{quote.recruiter_name}</TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                        <Chip size="small" label={`${quote.jobs_purchased || 0} Jobs`} variant="outlined" />
                                        <Chip size="small" label={`${quote.applications_purchased || 0} Apps`} variant="outlined" />
                                        {quote.call_alerts_purchased > 0 && (
                                            <Chip size="small" label={`${quote.call_alerts_purchased} Calls`} variant="outlined" color="info" />
                                        )}
                                        {quote.whatsapp_alerts_purchased > 0 && (
                                            <Chip size="small" label={`${quote.whatsapp_alerts_purchased} WA`} variant="outlined" color="success" />
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ fontWeight: 700, color: '#059669' }}>₹{Number(quote.total_amount).toLocaleString()}</TableCell>
                                <TableCell><StatusChip status={quote.status} /></TableCell>
                                <TableCell>{new Date(quote.created_at).toLocaleDateString()}</TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            startIcon={<Eye size={14} />}
                                            onClick={() => { setSelectedQuote(quote); setPreviewModal(true); }}
                                        >
                                            Preview
                                        </Button>
                                        {quote.status === 'draft' && (
                                            <Button
                                                size="small"
                                                variant="contained"
                                                startIcon={<Send size={14} />}
                                                onClick={() => handleGenerateLink(quote.id)}
                                            >
                                                Send Link
                                            </Button>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>



            </TableContainer>
            <Box
                sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }}
            >
                <Typography sx={{ color: '#718096', fontSize: '0.875rem' }}>
                    {filteredQuotes.length === 0
                        ? "0–0 of 0 records"
                        : `${(page - 1) * rowsPerPage + 1}–${Math.min(
                            page * rowsPerPage,
                            filteredQuotes.length
                        )} of ${filteredQuotes.length} records`}
                </Typography>

                {totalPages > 1 && (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            size="small"
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                            sx={{
                                minWidth: 32,
                                height: 32,
                                p: 0
                            }}
                        >
                            <NavigateBefore />
                        </Button>

                        {[...Array(totalPages)].map((_, i) => (
                            <Button
                                key={i}
                                size="small"
                                onClick={() => setPage(i + 1)}
                                sx={{
                                    minWidth: 32,
                                    height: 32,
                                    p: 0,
                                    borderRadius: '50%',
                                    bgcolor: page === i + 1 ? '#1E3A8A' : 'transparent',
                                    color: page === i + 1 ? '#fff' : '#1f2937'
                                }}
                            >
                                {i + 1}
                            </Button>
                        ))}

                        <Button
                            size="small"
                            disabled={page === totalPages}
                            onClick={() => setPage(page + 1)}
                            sx={{
                                minWidth: 32,
                                height: 32,
                                p: 0
                            }}
                        >
                            <NavigateNext />
                        </Button>
                    </Box>
                )}
            </Box>

            {/* Create Quote Modal */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 800 }}>Create Custom Quote</DialogTitle>
                <DialogContent>
                    <Box sx={{ py: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
                        {searchError && <Alert severity="error" sx={{ mb: 2 }}>{searchError}</Alert>}
                        <Autocomplete
                            options={companies}
                            loading={searching}
                            getOptionLabel={(option) => `${option.formatted_company_id} | ${option.company_name} | ${option.email}`}
                            noOptionsText={searchTerms.length < 2 ? "Type at least 2 characters" : "No companies found"}
                            onInputChange={(e, val) => {
                                setSearchTerms(val);
                                handleSearchCompanies(val);
                            }}
                            onChange={(e, val) => setSelectedCompany(val)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search Company by ID, Name or Email"
                                    fullWidth
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {searching ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    label="Jobs Quantity"
                                    type="number"
                                    fullWidth
                                    value={formData.jobs_quantity}
                                    onChange={(e) => setFormData({ ...formData, jobs_quantity: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Applications Quantity"
                                    type="number"
                                    fullWidth
                                    value={formData.applications_quantity}
                                    onChange={(e) => setFormData({ ...formData, applications_quantity: e.target.value })}
                                />
                            </Grid>

                            {/* Optional Add-ons */}
                            <Grid item xs={12}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontWeight: 600, mt: 1 }}>
                                    Optional Add-ons
                                </Typography>
                            </Grid>

                            {/* Call Alerts */}
                            <Grid item xs={6}>
                                <TextField
                                    label="📞 Call Alerts"
                                    type="number"
                                    fullWidth
                                    value={formData.call_alerts_quantity}
                                    inputProps={{ min: 0 }}
                                    onChange={(e) => setFormData({ ...formData, call_alerts_quantity: Math.max(0, Number(e.target.value)) })}
                                />
                            </Grid>

                            {/* WhatsApp Alerts */}
                            <Grid item xs={6}>
                                <TextField
                                    label="💬 WhatsApp Alerts"
                                    type="number"
                                    fullWidth
                                    value={formData.whatsapp_alerts_quantity}
                                    inputProps={{ min: 0 }}
                                    onChange={(e) => setFormData({ ...formData, whatsapp_alerts_quantity: Math.max(0, Number(e.target.value)) })}
                                />
                            </Grid>
                        </Grid>

                        <TextField
                            label="Negotiated Amount"
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                            }}
                            value={formData.negotiated_amount}
                            onChange={(e) => setFormData({ ...formData, negotiated_amount: e.target.value })}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                    <Button onClick={() => setOpenModal(false)} color="inherit">Cancel</Button>
                    <Button
                        onClick={handleCreateQuote}
                        variant="contained"
                        disabled={!selectedCompany || !formData.negotiated_amount}
                    >
                        Create Quote
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Preview Modal */}
            <Dialog open={previewModal} onClose={() => setPreviewModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 800, textAlign: 'center' }}>Quote Preview</DialogTitle>
                <DialogContent>
                    {selectedQuote && (
                        <Box sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="h6" sx={{ color: '#2563eb', fontWeight: 800 }}>ExiHire</Typography>
                                <Typography variant="body2" color="text.secondary">Quote ID: {selectedQuote.quote_id}</Typography>
                            </Box>

                            <Grid container spacing={4} sx={{ mb: 4 }}>
                                <Grid item xs={6}>
                                    <Typography variant="caption" color="text.secondary">BILL TO:</Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 700 }}>{selectedQuote.company_name}</Typography>
                                    <Typography variant="body2">{selectedQuote.recruiter_name}</Typography>
                                    <Typography variant="body2">ID: {selectedQuote.formatted_company_id}</Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                    <Typography variant="caption" color="text.secondary">DATE:</Typography>
                                    <Typography variant="body2">{new Date(selectedQuote.created_at).toLocaleDateString()}</Typography>
                                </Grid>
                            </Grid>

                            <Table sx={{ mb: 3 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700 }}>Description</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700 }}>Qty</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Job Posting Credits</TableCell>
                                        <TableCell align="right">{selectedQuote.jobs_purchased}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Application Processing Credits</TableCell>
                                        <TableCell align="right">{selectedQuote.applications_purchased}</TableCell>
                                    </TableRow>
                                    {selectedQuote.call_alerts_purchased > 0 && (
                                        <TableRow>
                                            <TableCell>Call Alerts</TableCell>
                                            <TableCell align="right">{selectedQuote.call_alerts_purchased}</TableCell>
                                        </TableRow>
                                    )}
                                    {selectedQuote.whatsapp_alerts_purchased > 0 && (
                                        <TableRow>
                                            <TableCell>WhatsApp Alerts</TableCell>
                                            <TableCell align="right">{selectedQuote.whatsapp_alerts_purchased}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                                <Box sx={{ display: 'flex', gap: 4 }}>
                                    <Typography color="text.secondary">Subtotal:</Typography>
                                    <Typography sx={{ fontWeight: 600 }}>₹{selectedQuote.total_amount}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 4 }}>
                                    <Typography color="text.secondary">Tax:</Typography>
                                    <Typography sx={{ fontWeight: 600 }}>₹0.00</Typography>
                                </Box>
                                <Divider sx={{ width: '200px', my: 1 }} />
                                <Box sx={{ display: 'flex', gap: 4 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 800 }}>Total:</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#059669' }}>₹{selectedQuote.total_amount}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                    <Button onClick={() => setPreviewModal(false)}>Close</Button>
                    {selectedQuote?.status === 'draft' && (
                        <Button variant="contained" onClick={() => handleGenerateLink(selectedQuote.id)}>Generate & Send Link</Button>
                    )}
                </DialogActions>
            </Dialog>
            {/* Payment Link Success Dialog */}
            <Dialog
                open={successDialog}
                onClose={() => setSuccessDialog(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '20px',
                        textAlign: 'center',
                        p: 2,
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogContent sx={{ py: 4 }}>
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            bgcolor: '#ecfdf5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 3
                        }}
                    >
                        <CheckCircle2
                            size={48}
                            color="#10b981"
                        />
                    </Box>

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1
                        }}
                    >
                        Payment Link Sent
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: '#6b7280',
                            lineHeight: 1.8
                        }}
                    >
                        {successMessage}
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'center',
                        pb: 3
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() => setSuccessDialog(false)}
                        sx={{
                            minWidth: 120,
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 600
                        }}
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CustomPricingDashboard;